import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import ArticlePageLayout from '../../../components/DataDisplay/ArticlePageLayout';
import {WarningIcon} from '../../../components/Icons';
import {PopupFullPage} from '../../../components/Popup';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import ModalTypes from '../../../enums/app/modalTypes';
import analyticsService from '../../../services/analyticsService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import appRouterService from '../../../services/route/appRouterService';
import {hideModalAction} from '../../../state/ducks/modal';
import {selectIotDeviceType} from '../../../state/selectors/iotDevice';
import {makeSelectVisibleGlobalModal} from '../../../state/selectors/modal';
import {dispatch} from '../../../state/store';

const UWMUnavailabilityPopup = ({refreshAction}) => {
    const localizedStrings = getLocalizedStrings();
    const deviceType = useSelector(selectIotDeviceType);
    const isVisibleQSGPopup = useSelector(makeSelectVisibleGlobalModal(ModalTypes.QUICK_START_GUIDE_POPUP));

    const onCancelClick = () => {
        dispatch(hideModalAction(ModalTypes.UWM_UNAVAILABILITY));

        if (isVisibleQSGPopup) {
            dispatch(hideModalAction(ModalTypes.QUICK_START_GUIDE_POPUP));
        } else {
            appRouterService.forwardToDeviceSettingsPage();
        }
    };

    useEffect(() => {
        analyticsService.pushUnavailableUWMEvent(deviceType);
    }, []);

    return (
        <PopupFullPage contentLabel={localizedStrings[localizationKeys.UWM_UNAVAILABILITY_POPUP_TITLE]}>
            <ArticlePageLayout
                containerClassName='pb-0 pt-[40px] lg:pt-[88px]'
                className='lg:max-w-[724px]'
                icon={<WarningIcon className='mb-4 h-6 w-6 lg:mb-6 lg:h-8 lg:w-8' />}
                titleText={localizedStrings[localizationKeys.UWM_UNAVAILABILITY_POPUP_TITLE]}
                descriptionText={localizedStrings[localizationKeys.UWM_UNAVAILABILITY_POPUP_DESCRIPTION]}
                buttonsDirection='column'
                buttonPrimary={{
                    onClick: refreshAction,
                    textKey: localizationKeys.UWM_UNAVAILABILITY_POPUP_REFRESH_BUTTON_TEXT,
                    isConnectionTrack: true,
                }}
                buttonSecondary={{
                    onClick: onCancelClick,
                    textKey: localizationKeys.UWM_UNAVAILABILITY_POPUP_NOT_NOW_BUTTON_TEXT,
                }}
            />
        </PopupFullPage>
    );
};

export default UWMUnavailabilityPopup;
